<template>
<div class="papsi-wrapper">
    <h1 class="text-2xl font-bold text-[#016B00]">DASHBOARD</h1>
    <p class="text-xs text-[#747474] mt-2">Home / Dashboard</p>
</div>
<div class="papsi-wrapper mt-6 w-full bg-[#e6e6e6]">
    <div class="papsi-container w-full flex flex-col gap-4">
        <div class="grid grid-cols-6 gap-3">
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">Total Employee</p>
                    <p class="font-bold text-[30px] text-[#016B00]">{{ totalEmployee }}</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/woman.png">
                </div>
            </div>
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">On-time</p>
                    <p class="font-bold text-[30px] text-[#016B00]">0</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/clock.png">
                </div>
            </div>
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">Absent</p>
                    <p class="font-bold text-[30px] text-[#016B00]">0</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/absence.png">
                </div>
            </div>
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">Late</p>
                    <p class="font-bold text-[30px] text-[#016B00]">0</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/late.png">
                </div>
            </div>
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">Halfday</p>
                    <p class="font-bold text-[30px] text-[#016B00]">0</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/half.png">
                </div>
            </div>
            <div :class="borderDesign">
                <div class="">
                    <p class="text-xs font-semibold text-[#a8a8a8]">Undertime</p>
                    <p class="font-bold text-[30px] text-[#016B00]">0</p>
                </div>
                <div class="rounded-full bg-[#026b0021] w-[60px] h-[60px] flex items-center justify-center">
                    <img class="w-[30px] h-[30px] object-fit" src="../../assets/undertime.png">
                </div>
            </div>
        </div>
        <div class="grid grid-cols-8 gap-3 h-[61vh]">
            <div class="col-span-4 ">
                <div :class="reuqestDesign" class="h-[100%]">
                    <div>
                        <div>
                            <p class="text-[#016B00] font-semibold text-medium">Form Request</p>
                        </div>
                        <div class="flex flex-col py-3 h-full gap-5  mt-3">
                            <div class="flex flex-col flex-1">
                              <p class="text-sm text-[#929292] mb-1 ml-1 drop-shadow-lg">Leave Request</p>
                              <div class="bg-[#ffffff] flex-1 min-h-[11vh] rounded drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] flex items-center justify-center w-full border border-[#d1cfcf]">
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/pending.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Pending</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ leaveInfo.pending}}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/completed.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Approved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ leaveInfo.approved }}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[50px]" src="../../assets/declined.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Disapproved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ leaveInfo.disapproved }}</p></div>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col flex-1">
                              <p class="text-sm text-[#929292] mb-1 ml-1">Consideration Request</p>
                              <div class="bg-[#ffffff] flex-1 min-h-[11vh] rounded drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] flex items-center justify-center w-full border border-[#d1cfcf]">
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/pending.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Pending</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ consiInfo.pending }}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/completed.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Approved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ consiInfo.approved }}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[50px]" src="../../assets/declined.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Disapproved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ consiInfo.disapproved }}</p></div>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col flex-1">
                              <p class="text-sm text-[#929292] mb-1 ml-1">Overtime Request</p>
                              <div class="bg-[#ffffff] flex-1 min-h-[11vh] rounded drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] flex items-center justify-center w-full border border-[#d1cfcf]">
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/pending.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Pending</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ overtimeInfo.pending }}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[40px]" src="../../assets/completed.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Approved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ overtimeInfo.approved }}</p></div>
                                    </div>
                                </div>
                                <div class="w-[33.33%] flex items-center justify-center gap-5">
                                    <div>
                                        <img class="w-[50px]" src="../../assets/declined.png">
                                    </div>
                                    <div>
                                        <div class="text-center text-xs text-[#929090] font-semibold"><p>Disapproved</p></div>
                                        <div class="text-center text-lg font-semibold text-[#575857]"><p>{{ overtimeInfo.disapproved }}</p></div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
            <div class="col-span-2">
                <div :class="reuqestDesign" class="h-full">
                    <div>
                        <div>
                            <p class="text-[#016B00] font-semibold text-medium">User Monitoring</p>
                        </div>

                        <div class="flex flex-col pb-4 mt-6 overflow-y-auto h-[50vh]">
                            <div v-for="(data, index) in user_login" :key="index" class="flex gap-2 border-b py-2">
                                <div class="flex">
                                    <div class="flex justify-center flex-col">
                                        <p class="font-semibold text-sm text-[#016B00]">{{ data.employee_name}}</p>
                                        <p class="font-semibold text-[11px] text-[#9b9a9a]"> The user logged in on : {{ data.login_datetime }}</p>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-2">
                <div :class="reuqestDesign" class="h-full">
                    <div>
                        <div>
                            <p class="text-[#016B00] font-semibold text-medium">Upcoming Birthdays</p>
                        </div>
                        <div class="flex flex-col pb-4 mt-6 overflow-y-auto h-[50vh]">
                            <div v-for="(data, index) in birthday" :key="index" class="flex gap-2 border-b py-2">
                                <div  class="flex flex-col  items-center  justify-center rounded-lg w-[10px] bg-[#c9c8c231] py-1 px-6 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] border-[#dbd9d9] border">
                                    <div class="text-[#5e5d5d] font-semibold text-xs">
                                        <p>{{ numberToMonth(data.birth_date.substring(0,2)) }}</p>
                                    </div>
                                    <div class="font-bold text-medium text-[#016B00]">
                                        <p>{{ data.birth_date.substring(3,5) }}</p>
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="flex justify-center flex-col">
                                        <p class="font-semibold text-sm text-[#5f5f5f]">{{ data.fname}}</p>
                                        <p class="font-semibold text-[11px] text-[#9b9a9a]">{{ describeDate(data.birth_date) }}</p>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>


<script>

    import Services from "../../services/admin"
    import { defineComponent } from 'vue';
    
    export default defineComponent(
    {
        components:{
        
        },
        data() {
            return {
                user_login: '',
                totalEmployee: "0",
                info:      null,
                leaveInfo: '',
                consiInfo: '',
                overtimeInfo: '',
                birthday:  '',
                reuqestDesign: 'drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] border-[#b6b8b8] border bg-[#fcfbfb] rounded-xl py-6 px-7 shadow-lg',
                borderDesign:'drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.2)] border-[#b6b8b8] border bg-[#fcfbfb] rounded-xl flex justify-between py-8 px-7 shadow-lg items-center col-span-1 max-xl:col-span-3'
            }
        },
        mounted(){
           this.getDashboardInformation();
        },
        methods:{
            numberToMonth(num) {
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                // Ensure the number is between 1 and 12
                const index = parseInt(num, 10);
                if (index >= 1 && index <= 12) {
                return months[index - 1];
                }
                return "Invalid"; // or return empty string or throw error
            },
            async getDashboardInformation(){
                this.$emit("showLoader")
                const success       =  await Services.getDashboardDetails()
                this.info           =  success.data
                this.totalEmployee  =  this.info.totalemployee
                this.user_login     =  this.info.user_login
                this.birthday       =  this.info.birthday
                this.leaveInfo      =  this.info.leave_details
                this.consiInfo      =  this.info.consi_details
                this.overtimeInfo   =  this.info.overtime_details
                this.$emit("hideLoader")
            },
            describeDate(dateStr) {
                let inputDate;

                if (dateStr === 'now') {
                const now = new Date();
                inputDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                } else {
                // Parse MM/DD/YYYY and replace year with current year
                const [month, day] = dateStr.split('/').map(Number);
                const currentYear = new Date().getFullYear();
                inputDate = new Date(currentYear, month - 1, day); // Month is 0-based
                }

                // Today's and yesterday's date
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);

                if (inputDate.getTime() === today.getTime()) {
                return 'Today';
                } else if (inputDate.getTime() === yesterday.getTime()) {
                return 'Yesterday';
                } else {
                const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return weekdays[inputDate.getDay()];
                }
            }
        }

    })

</script>